<template>
    <div class="popup-modal animate__animated animate__fadeIn" v-if="isVisible">
      <div class="pop-up-window animate__bounceInDown animate__animated">
        <slot></slot>
      </div>
    </div>
</template>

<script>
export default {
  name: 'PopupModal',

  data: () => ({
    isVisible: false,
  }),

  methods: {
    open() {
      this.isVisible = true;
    },

    close() {
      this.isVisible = false;
    },
    fade() {
      setTimeout(() => {
        this.isVisible = false;
      }, 2500);
    },
  },
};
</script>
